import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

/** Components */
import Skeleton from '@mui/material/Skeleton';
import PageContainer from '../../components/PageContainer';
import RemovebgLogsFilters from '../../components/RemovebgLogsFilters';
import RemovebgLogsTable from '../../components/RemovebgLogsTable';
import { PageHeader } from '../../components/ui';

/** Selectors */
import { getRemovebgLogs } from '../../store/thunk/removebgLogs';
import { IStore } from '../../store/types';
import Dayjs from 'dayjs';

const DEFAULT_PAGING_STATE = {
    maxDate: Dayjs(new Date()).format("YYYY-MM-DD"),
    minDate: Dayjs(new Date()).format("YYYY-MM-DD"),
    limit: 100,
    page: 1,
    sortDirection: 'DESC',
    total: 0,
    status: '',
    targetResolution: '',
    isRetryExist: ''
};

const RemovebgLogsPage = () => {
    const {
        removebgLogs,
        status,
        queryParams
    } = useSelector<IStore, { removebgLogs: any, status: string, queryParams: any }>(state => ({
        removebgLogs: state.removebgLogs.data,
        status: state.removebgLogs.status,
        queryParams: state.removebgLogs.queryParams
    }));

    const dispatch = useDispatch();

    const loadLogs = (queryParams) => {
        dispatch<any>(getRemovebgLogs(queryParams));
    };

    const handleChangePage = (event: unknown, newPage: number) => {
        const newParams = {...queryParams, page: newPage + 1};
        dispatch<any>(getRemovebgLogs(newParams));
    };

    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newLimit = parseInt(event.target.value, 10);
        dispatch<any>(getRemovebgLogs({...queryParams, limit: newLimit, page: 1}));
    };

    useEffect(() => {
        loadLogs(DEFAULT_PAGING_STATE);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <PageContainer constrained>
            <PageHeader eyebrow="Mockups" title="Remove background logs" subtitle="Background-removal runs with quality analysis; expand a row for the raw log." />
            <RemovebgLogsFilters
                queryParams={queryParams || DEFAULT_PAGING_STATE}
                loadLogs={loadLogs}
                loading={status === 'loading'}
            />
            {status === 'loading' && !removebgLogs ? (
                <Skeleton variant="rounded" animation="wave" width="100%" height={400} />
            ) : (
                <RemovebgLogsTable
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            )}
        </PageContainer>
    );
};

export default RemovebgLogsPage; 